import { render, staticRenderFns } from "./AsfaBalancePage.vue?vue&type=template&id=41a7a891&scoped=true"
import script from "./AsfaBalancePage.vue?vue&type=script&lang=ts"
export * from "./AsfaBalancePage.vue?vue&type=script&lang=ts"
import style0 from "./AsfaBalancePage.vue?vue&type=style&index=0&id=41a7a891&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a7a891",
  null
  
)

export default component.exports